exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider{width:100%;height:auto}.bar-content{width:275px;margin:30px auto;display:flex}.bar{width:85px;height:0}.bar-anchor:not(:last-child){margin-right:10px}.current{border:3px solid #4b74ff}.not-current{border:3px solid #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-968e8298","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MainSlider.vue
// module id = 105
// module chunks = 0